<template>
  <div class="layout-center-wrap">
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">취약점 조치</h1>
      <h2 class="page-tit">취약점 패치 관리</h2>
    </div>
    <div class="board-list__top">
      <p class="board-list__total">총 {{ total }}건</p>
      <div class="board-list__search_ch">
        <label for="search-type" class="sr-only">검색 조건</label>
        <p class="board-list__search-tit">KVE</p>
        <label for="search-keyword" class="sr-only"
          >검색어를 입력해주세요</label
        >
        <input
          v-model="searchInfo.content"
          type="text"
          id="search-keyword"
          placeholder="검색어를 입력해주세요"
        />
        <p class="board-list__search-tit">조치 구분</p>
        <select name="" id="search-type" v-model="searchInfo.submitType">
          <option value="">선택해주세요.</option>
          <option value="R">조치 결과 접수</option>
          <option value="P">조치 계획서 접수</option>
        </select>
        <button type="button" class="btn btn--blue btn--m" @click="getList(1)">
          <i class="svg_icon icon_search white"></i>검색
        </button>
        <button
          type="button"
          class="btn btn--green btn--m"
          @click="downloadConfirm()"
        >
          조치확인서
        </button>
      </div>
    </div>
    <!-- v-for 적용 테이블 -->
    <table class="board-list type-block--mobile">
      <caption>
        패치 접수 목록
      </caption>
      <colgroup>
        <col width="5%" />
        <col width="15%" />
        <col width="30%" />
        <col width="20%" />
        <col width="10%" />
        <col width="10%" />
        <col width="10%" />
      </colgroup>
      <thead>
        <tr>
          <th scope="col">
            <label class="chk">
              <input type="checkbox" class="chk" v-model="isAllChecked" />
            </label>
          </th>
          <th scope="col">등록일</th>
          <th scope="col">KVE</th>
          <th scope="col">대상제품명</th>
          <th scope="col">패치구분</th>
          <th scope="col">조치 가능 여부</th>
          <th scope="col">버전</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in items"
          :key="item.id"
          @click="goToDetail(item)"
          class="clickable-row"
        >
          <td class="chk-field">
            <label class="chk"
              ><input
                type="checkbox"
                class="chk"
                :value="item.kve"
                v-model="checkedItems"
                @click.stop
            /></label>
          </td>
          <td class="date-field">
            {{ convertDateFormat(item.patchInfo.regDate) }}
          </td>
          <td class="tit-field">
            <div class="ellipsis">{{ item.kve }}</div>
          </td>
          <td class="info-field">
            <div class="ellipsis">{{ item.swNm || "-" }}</div>
          </td>
          <td class="info-field">{{ convertSubmitType(item.gubun) }}</td>
          <td class="info-field">
            {{ convertHasActionOk(item.patchInfo.hasActionOk) }}
          </td>
          <td class="no-field">{{ item.isMatch }}</td>
        </tr>
      </tbody>
    </table>
    <div v-if="items == null || items.length == 0" class="no-data">
      {{
        isLoading
          ? "데이터 조회중입니다. 잠시만 기다려주십시오."
          : "검색 결과 없음..."
      }}
    </div>
    <Paging
      v-model="pagingInfo.currentPage"
      :totalItems="total"
      :visibleCount="pagingInfo.limitNum"
      @update:modelValue="getPage"
    />
  </div>
</template>
<script>
import dc from "@/component/DataChk.js";
import dt from "@/component/DateTime.js";
import pageNav from "@/component/PageNav.vue";
import pageSelect from "@/component/PageSelect.vue";
import paging from "@/component/Paging.js";
import tb from "@/component/Table.js";
import { computed, onMounted, reactive, ref, watch, inject } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: { pageSelect, pageNav },

  setup() {
    const saver = inject("filesaver");
    const axios = inject("axios");
    const router = useRouter();
    const store = useStore();
    // data 정의
    const pagingInfo = reactive({
      currentPage: 1, // 현재페이지
      prePage: 1, // 이전페이지
      perPage: 10, // n개씩보기
      limitNum: 5, // 화면에 표시할 페이지 수
      type: 1, // 1 = 처음부터 조회, 2 = preKey/nextKey 사용, 3 = n개씩보기 변경
      total: -1,
      pageNum: 0,
      doubleTab: false,
    });
    const searchInfo = ref({
      sortBy: "_id",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      content: "",
      submitType: "",
      tabs: "",
    });
    const savedSearchInfo = ref({
      // getList(1) 후 저장된 검색 조건
      sortBy: "regDate",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      submitType: "",
      content: "",
      tabs: "",
    });
    const total = ref(-1);
    const items = ref([]);
    const itemsSize = ref(0);
    const checkedItems = ref([]);

    // methods 정의
    const getList = async (type) => {
      searchInfo.value = dc.trimObject(searchInfo.value);
      const axiosSearchInfo = tb.getSearchInfo(
        type,
        searchInfo,
        savedSearchInfo
      );

      pagingInfo.type = type;
      if (type !== 2) {
        total.value = -1;
        paging
          .total("/patch/pr/records/count/get", axiosSearchInfo)
          .then((res) => {
            total.value = res;
            itemsSize.value = res;
          });
      }

      paging
        .getPageItems("/patch/pr/records/get", axiosSearchInfo, pagingInfo)
        .then((res) => {
          items.value = res;
          pagingInfo.doubleTab = true;
        });

      // 검색 조건 저장
      tb.saveSearchInfo(type, searchInfo, savedSearchInfo);
    };
    const convertId = (index) => {
      // total.value 쉼표를 제거하고 숫자로 변환
      const totalCount = parseInt(String(total.value).replace(/,/g, ""), 10);
      if (isNaN(totalCount) || totalCount <= 0) {
        return 0;
      }
      const offset = (pagingInfo.currentPage - 1) * pagingInfo.perPage;

      if (pagingInfo.currentPage > 1) {
        return totalCount - offset - index;
      }
      return totalCount - index;
    };
    const goToDetail = (item) => {
      // 검색 조건을 sessionStorage에 저장
      tb.saveStateForDetail("patchRecord", searchInfo.value, pagingInfo);
      // 상세 페이지로 이동
      router.push({
        name: "patchRecordDetail",
        query: { id: item.id },
      });
    };

    const getPage = (page) => {
      checkedItems.value = [];
      // 페이징 클릭 시 목록 조회
      pagingInfo.currentPage = page;
      pagingInfo.pageNum = page - pagingInfo.currentPage; // 클릭한 페이지 기준 차이
      pagingInfo.doubleTab = false;
      getList(2);
    };

    const convertDateFormat = (date) => {
      return dt.dateTimeFormat(date);
    };
    const convertSubmitType = (data) => {
      if (data === "P") {
        return "조치 계획서 접수";
      }
      return "조치 결과 접수";
    };
    const convertHasActionOk = (data) => {
      return data ? "가능" : "불가능";
    };

    const downloadConfirm = () => {
      if (!checkedItems.value.length) {
        alert("선택된 항목이 없습니다.");
        return;
      }

      // showLoading();
      axios({
        method: "POST",
        url: "/patch/pr/submission/confirm/download",
        responseType: "blob",
        data: checkedItems.value,
      })
        .then((response) => {
          if (response.data.size === 0) {
            alert(
              "파일 경로가 잘못되었거나 필수 데이터가 누락되어 파일을 생성할 수 없습니다."
            );
            return;
          }
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          // KVE  새로운 파일명 생성
          const newFileName = `${checkedItems.value[0]}외_${checkedItems.value.length}건_조치확인서.zip`;
          saver.saveAs(blob, newFileName);
          checkedItems.value = [];
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          // hideLoading();
        });
    };

    // computed 정의
    const isLoading = computed(() => store.state.loading.isLoading);
    const isAllChecked = computed({
      get() {
        return (
          items.value.length > 0 &&
          checkedItems.value.length === items.value.length
        );
      },
      set(value) {
        if (value) {
          checkedItems.value = items.value.map((item) => item.kve);
        } else {
          checkedItems.value = [];
        }
      },
    });

    // life cycle 정의
    onMounted(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      const retrievedState = tb.retrieveAndClearState(
        "patchRecord",
        "patchRecordDetail",
        searchInfo,
        savedSearchInfo,
        pagingInfo
      );
      const {
        type: type,
        searchInfo: parsedSearchInfo,
        pagingInfo: parsedPagingInfo,
      } = retrievedState;
      getList(type);
    });

    // html에서 사용될 데이터 정의
    return {
      pagingInfo,
      searchInfo,
      getList,
      items,
      total,
      getPage,
      convertDateFormat,
      goToDetail,
      convertId,
      checkedItems,
      convertSubmitType,
      convertHasActionOk,
      isLoading,
      isAllChecked,
      downloadConfirm,
    };
  },
};
</script>
